import { Head, Link } from '@inertiajs/react'
import { ArrowLeft } from 'lucide-react'
import DashboardLayout from '@/frontend/layouts/DashboardLayout'
import ProfileEditor from '@/frontend/features/AgentProfiles/ProfileEditor'
import type { AgentProfile, ProfileCopy } from '@/frontend/features/AgentProfiles/types'

function EditAgentProfile({ profile, copy }: { profile: AgentProfile; copy: ProfileCopy }) {
  return <div className="mx-auto max-w-3xl px-6 py-8"><Head title={profile.id ? `${profile.name} · ${copy.edit}` : copy.new} />
    <Link href="/dashboard/agent_profiles" className="inline-flex items-center gap-2 text-sm text-muted-foreground"><ArrowLeft className="size-4" />{copy.title}</Link>
    <h1 className="mb-2 mt-6 text-2xl font-semibold tracking-tight">{profile.id ? profile.name : copy.new}</h1>
    <p className="mb-8 text-sm leading-relaxed text-muted-foreground">{copy.description}</p>
    <ProfileEditor key={`${profile.id || 'new'}:${profile.lock_version}`} profile={profile} copy={copy} />
  </div>
}
EditAgentProfile.layout = (page: React.ReactElement) => <DashboardLayout>{page}</DashboardLayout>
export default EditAgentProfile
